import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { BookingsPageMain } from "./main";

export const BookingsPage: FC = () => {
  return (
    <PageContextWrapper entity="booking">
      <BookingsPageMain />
    </PageContextWrapper>
  );
};
